module.exports = __webpack_public_path__ + "img/fi-korean-food-200x132.ba3cb254.jpg";